import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({component: Component, authed, unauthedRoute, ...rest}) => {
    return (
        <Route
            {...rest}
            render={(props) => authed === true
                ? <Component {...props} />
                : <Redirect to={{pathname: unauthedRoute || "/login", state: {from: props.location}}} />}
        />
    )
}

export default PrivateRoute;